// src/App.js
import React, { useState, useEffect } from "react";
import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login";
import Dashboard from "./pages/Dashboard";
import ErrorPopup from "./components/common/ErrorPopup";

const App = () => {
	const [auth, setAuth] = useState(!!localStorage.getItem("token"));
	const [globalError, setGlobalError] = useState("");
	const [errorOpen, setErrorOpen] = useState(false);

	// Expose a global function to show error popup
	useEffect(() => {
		window.showGlobalError = (errorMessage) => {
			setGlobalError(errorMessage);
			setErrorOpen(true);
		};
		return () => {
			delete window.showGlobalError;
		};
	}, []);

	return (
		<Router>
			{/* Global Error Popup */}
			<ErrorPopup open={errorOpen} error={globalError} onClose={() => setErrorOpen(false)} />
			<Routes>
				<Route path="/" element={!auth ? <Navigate to="/login" /> : <Navigate to="/dashboard" />} />
				<Route path="/login" element={<Login setAuth={setAuth} />} />
				<Route path="/dashboard" element={auth ? <Dashboard /> : <Navigate to="/login" />} />
			</Routes>
		</Router>
	);
};

export default App;
